import React, { useState } from "react";

import useLoudness from "../../hooks/useLoudness";
import useMuteWarning from "../../hooks/useMuteWarning";
import KeypadButton from "./KeypadButton";
import { MdPhoneInTalk } from "react-icons/md";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";

const OnCall = ({ handleHangup, connection }) => {
  const [muted, setMuted] = useState(false);
  const [running, setRunning, loudness] = useLoudness();
  const [showMuteWarning] = useMuteWarning(loudness, running);

  const handleMute = () => {
    connection.mute(!muted);
    setMuted(!muted);
    setRunning(!muted);
  };

  const muteWarning = <p className="warning">¿Estas hablando? Estas muteado</p>;

  return (
    <>
      <div className=" max-w-xs mx-auto px-2 py-10 rounded-lg bg-gray-50 shadow-lg mt-20 w-full">
        <div className=" col-span-2 pb-4">
          <p className=" text-center font-bold text-gray-700">
            Llamada en curso
          </p>
        </div>
        <div className="grid grid-cols-2 gap-2 ">
          <div className=" flex justify-center">
            <button
              onClick={handleMute}
              className=" "
            >
            <div className="bg-red-600 h-auto p-5 text-white rounded-full ">
           {muted ?  <FaMicrophoneSlash /> : <FaMicrophone/>}
            </div>
            </button>
          </div>
          <button
            type="button"
            onClick={handleHangup}
            className="flex justify-center gap-2 items-center p-3 hover:animate-none hover:bg-gray-800 hover:bg-opacity-10 hover:scale-105 hover:transition duration-300   bg-gray-700 bg-opacity-10 text-gray-600 font-bold rounded-md "
          >
            <span className=" z-[9995]">Finalizar</span>
            <div className="    bg-white p-3 rounded-full">
              <MdPhoneInTalk className=" animate" />
            </div>
          </button>
        </div>
      </div>
      {/* {showMuteWarning && muteWarning}
      <div className="call">
        <div className="call-options">
          <KeypadButton handleClick={handleMute} color={muted ? "red" : ""}>
            {muted ? "Unmute" : "Mute"}
          </KeypadButton>
        </div>
        <div className="hang-up">
          <KeypadButton handleClick={handleHangup} color="red">
            Hang up
          </KeypadButton>
        </div>
      </div> */}
    </>
  );
};

export default OnCall;
